export default __webpack_public_path__ + "static/media/MGI_poweredby_logo1.37c290b4.png";